import { useCallback } from 'react';

import { validateEmail } from 'lib/helpers';
import { showErrorToast } from 'lib/errors';
import { successToast } from 'utils/toast';
import {
    getImplementationSchema,
    exportImplementations as exportImplementationsApi,
} from 'lib/services/implementations';

const useExportImplementationsModal = ({ dispatch, state, t, userEmail }) => {
    const initialize = useCallback(
        (filters) => {
            dispatch({ type: 'openModal', filters });
            getImplementationSchema()
                .then(({ data }) => {
                    const options = (data.columns || []).map((column) => ({
                        id: column,
                        label: t(column),
                    }));

                    const fieldsSchema = [
                        {
                            label: t('cfm_label_all'),
                            id: 'fields',
                            options,
                        },
                    ];

                    const selected = {
                        fields: {
                            isSelected: false,
                            options: [],
                        },
                    };

                    dispatch({
                        type: 'setSchema',
                        data: {
                            email: userEmail,
                            fieldsSchema,
                            selected,
                        },
                    });
                })
                .catch((err) => {
                    console.error(err);
                    showErrorToast(t, err);
                });
        },
        [dispatch, t, userEmail],
    );

    const exportImplementations = useCallback(() => {
        if (!validateEmail(state.email)) {
            return dispatch({ type: 'setInvalidEmail' });
        }

        dispatch({ type: 'setLoading', value: true });

        const columns = state.selected.fields?.options || [];
        const requestData = {
            columns,
            emails: [state.email],
            query: state.filters?.searchText,
            filter: state.filters?.filter,
            plan: state.filters?.license,
        };

        exportImplementationsApi(requestData)
            .then(() => {
                successToast({
                    t,
                    text: t('label_toast_export_email_incoming'),
                });
            })
            .catch((error) => {
                showErrorToast(t, error);
            })
            .finally(() => {
                dispatch({ type: 'finishExport' });
            });
    }, [dispatch, state.email, state.filters, state.selected, t]);

    return { initialize, exportImplementations };
};

export default useExportImplementationsModal;
